
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"800","height":"800","viewBox":"0 0 64 64","fill":"#f7c948"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.998 2.478c.279 0 .463.509.463.509l8.806 18.759 20.729 3.167-14.999 15.38 3.541 21.701-18.54-10.254-18.54 10.254 3.541-21.701L2 24.912l20.729-3.167 8.798-18.743s.192-.524.471-.524m0-2.478c-.775 0-1.48.448-1.811 1.15l-8.815 18.778-19.674 3.007c-.741.113-1.356.632-1.595 1.343a2 2 0 0 0 .465 2.031l14.294 14.657-3.378 20.704c-.124.756.195 1.517.822 1.957.344.243.747.366 1.151.366a2.01 2.01 0 0 0 .968-.25l17.572-9.719 17.572 9.719a2.01 2.01 0 0 0 .968.25 1.99 1.99 0 0 0 1.151-.366c.627-.44.946-1.201.822-1.957l-3.378-20.704 14.294-14.657a2 2 0 0 0 .465-2.031c-.238-.711-.854-1.229-1.595-1.343l-19.674-3.006L33.809 1.15A2 2 0 0 0 31.998 0h0z"}}),_c('path',{attrs:{"d":"M31.998 2.478c.279 0 .463.509.463.509l8.806 18.759 20.729 3.167-14.999 15.38 3.541 21.701-18.54-10.254-18.54 10.254 3.541-21.701L2 24.912l20.729-3.167 8.798-18.743s.192-.524.471-.524"}})])
          )
        }
      }
    